import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { ExpiredDocumentsView } from "@containers/expired/ExpiredDocumentsView";

const ExpiredSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="expiredDocuments">
            <ExpiredDocumentsView />
        </AuthenticatedLayout>
    );
}

export default ExpiredSessionsPage;